import { useMutation } from '@tanstack/react-query'
import { axiosClient } from 'src/lib/axios'

const getCompanies = async () => {
  try {
    const res = await axiosClient.get('/user/super_user/company_client/')
    return res.data
  } catch (err) {
    console.error(err)
  }
}

export const useFetchGetCompanies = () => useMutation(async () => await getCompanies())

const createCompany = async (data) => {
  const res = await axiosClient.post('/user/super_user/company_client/', data)
  return res.data
}

export const useFetchcreateCompany = () => useMutation(async (data) => await createCompany(data))
